<template>
  <div class="item-view">
    <div class="item-contact" v-if="item">
      <div class="item-contact-actions">
        <button class="button-reset button-base button-primary item-contact-actions-button" type="button" @click="showModalMessage = true">
          <i class="fas fa-paper-plane"></i>Mejla
        </button>
        <button class="button-reset button-base button-primary item-contact-actions-button" type="button" v-if="item.phone" @click="showModalPhone = true">
          <i class="fas fa-phone"></i>Ring
        </button>
      </div>
    </div>
    <HeaderMain></HeaderMain>
    <main>
      <div class="container">
        <div class="item-header" v-if="item && nav && !resultLoading">
          <router-link :to="{ name: 'item-view', params: { slug: nav[pos - 1].slug, id: nav[pos - 1].id } }" class="item-header-nav item-header-nav-prev" v-if="pos > 0">
            <i class="fas fa-angle-left"></i>Föreg. annons
          </router-link>
          <span class="item-header-nav item-header-nav-prev-inactive" v-else>
            <i class="fas fa-angle-left"></i>Föreg. annons
          </span>
          <router-link :to="{ name: 'item-view', params: { slug: nav[pos + 1].slug, id: nav[pos + 1].id } }" class="item-header-nav item-header-nav-next" v-if="pos < nav.length - 1">
            Nästa annons<i class="fas fa-angle-right"></i>
          </router-link>
          <span class="item-header-nav item-header-nav-next-inactive" v-else>
            Nästa annons<i class="fas fa-angle-right"></i>
          </span>
        </div>
        <div class="item-header" v-else></div>
      </div>
      <div class="wrapper" v-if="resultLoading">
        <div class="container">
          <div class="centered">
            <div class="loader"></div>
          </div>
        </div>
      </div>
      <div class="wrapper" v-else-if="item">
        <ModalMessage v-show="showModalMessage" :show="showModalMessage" :itemId="item.id" @close="showModalMessage = !showModalMessage"></ModalMessage>
        <ModalPhone v-show="showModalPhone" :show="showModalPhone" :phoneNumber="item.phone" @close="showModalPhone = !showModalPhone"></ModalPhone>
        <ModalManageLink v-show="showModalManageLink" :show="showModalManageLink" :itemId="item.id" @close="showModalManageLink = !showModalManageLink"></ModalManageLink>
        <ModalItemReport v-show="showModalItemReport" :show="showModalItemReport" :itemId="item.id" @close="showModalItemReport = !showModalItemReport"></ModalItemReport>
        <div class="container">
          <span class="item-category">{{ item.subcategory.category.name }} <i class="fas fa-angle-right"></i> {{ item.subcategory.name }}</span>
          <div class="item-body">
            <div class="item-main">
              <div class="item-carousel-wrapper" v-if="this.item.images.length">
                <ImageCarousel :images="this.item.images"></ImageCarousel>
              </div>
              <div class="item-details">
                <div class="item-details-meta">
                  <span class="item-details-meta-location">
                    <i class="fas fa-map-marker-alt"></i><span v-html="item.area ? item.area.name : 'Gotland'"></span>
                  </span>
                  <span class="item-details-meta-date">
                    <i class="fas fa-clock"></i><time :datetime="item.created_at_local">{{ item.created_at_formatted }}</time>
                  </span>
                </div>
                <h1 class="item-details-title">{{ item.title }}</h1>
                <span class="item-details-price">{{item.price_formatted  }} kr</span>
                <span class="item-details-user">Säljes av <strong>{{ item.name }}</strong></span>
                <h3 class="item-details-heading">Beskrivning:</h3>
                <p class="item-details-paragraph" v-html="item.description"></p>
                <div class="item-details-bottom">
                  <span class="item-details-bottom-id">Annonsnr: {{ item.id }}</span>
                  <button class="button-reset item-report-button" type="button" @click="showModalItemReport = true">
                    <i class="fas fa-flag"></i>Anmäl annons
                  </button>
                </div>
                <div class="item-details-footer">
                  <button class="button-reset button-base button-secondary item-details-footer-edit-button" type="button" @click="showModalManageLink = true">
                    <i class="fas fa-marker"></i>Ändra/ta bort annons
                  </button>
                </div>
              </div>
            </div>
            <div class="item-meta">
              <div class="item-meta-box">
                <div class="item-meta-box-price">
                  <span>{{ item.price_formatted }} kr</span>
                </div>
                <ul class="list-reset item-meta-box-list">
                  <li class="item-meta-box-list-item">
                    <span class="item-meta-box-list-item-key">Plats</span>
                    <span class="item-meta-box-list-item-val" v-html="item.area ? item.area.name : 'Gotland'"></span>
                  </li>
                  <li class="item-meta-box-list-item">
                    <span class="item-meta-box-list-item-key">Inlagd</span>
                    <span class="item-meta-box-list-item-val">
                      <time :datetime="item.created_at_local">{{ item.created_at_formatted }}</time>
                    </span>
                  </li>
                </ul>
              </div>
              <div class="item-meta-box">
                <div class="item-meta-box-user">
                  <span>{{ item.name }}</span>
                </div>
                <button class="button-reset button-base button-primary item-meta-box-button item-meta-box-message-button" type="button" @click="showModalMessage = true">
                  <i class="fas fa-paper-plane"></i>Skicka meddelande
                </button>
                <button class="button-reset button-base button-primary item-meta-box-button item-meta-box-phone-button" type="button" v-if="item.phone" @click="showModalPhone = true">
                  <i class="fas fa-phone"></i>Visa telefonnummer
                </button>
              </div>
              <div class="item-meta-box">
                <button class="button-reset button-base button-secondary item-meta-box-button item-meta-box-edit-button" type="button" @click="showModalManageLink = true">
                  <i class="fas fa-marker"></i>Ändra/ta bort annons
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper" v-else-if="notFound">
        <div class="container">
          <div class="centered">
            <strong>Annonsen kunde inte hittas</strong>
            <p>Detta kan bero på att varan redan blivit såld eller att annonsören tagit bort den.</p>
            <router-link to="/" class="centered-link"><i class="fas fa-home"></i>Till startsidan</router-link>
          </div>
        </div>
      </div>
      <div class="wrapper" v-else>
        <div class="container">
          <div class="centered">
            <strong>Oj, nu blev det något fel!</strong>
            <p>Försök igen om en stund så borde det ha löst sig.</p>
          </div>
        </div>
      </div>
    </main>
    <FooterMain></FooterMain>
  </div>
</template>

<script>
import axios from 'axios'
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'
import ImageCarousel from '@/components/ImageCarousel.vue'
import ModalMessage from '@/components/modals/Message.vue'
import ModalPhone from '@/components/modals/Phone.vue'
import ModalManageLink from '@/components/modals/ManageLink.vue'
import ModalItemReport from '@/components/modals/ItemReport.vue'

export default {
  name: 'ItemView',
  components: {
    HeaderMain,
    FooterMain,
    ImageCarousel,
    ModalMessage,
    ModalPhone,
    ModalManageLink,
    ModalItemReport
  },
  data () {
    return {
      showModalMessage: false,
      showModalPhone: false,
      showModalManageLink: false,
      showModalItemReport: false,
      resultLoading: true,
      notFound: false,
      pos: 0,
      nav: null,
      item: null
    }
  },
  methods: {
    setPos () {
      this.nav.forEach((el, index) => {
        if (el.id == this.$route.params.id) {
          this.pos = index
        }
      })
    },
    getItem () {
      this.resultLoading = true

      axios.get(process.env.VUE_APP_API_ENDPOINT + '/items/' + this.$route.params.id)
      .then(response => {
        this.item = response.data
        this.resultLoading = false

        document.title = this.item.title + ' - ' + this.item.subcategory.category.name + ' / ' + this.item.subcategory.name + ' - Gluo'
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          this.notFound = true

          let meta = document.createElement('meta')
          meta.setAttribute('name', 'robots')
          document.head.appendChild(meta)
          meta.setAttribute('content', 'noindex')
        }

        this.resultLoading = false
      })
    }
  },
  watch: {
    $route () {
      this.getItem()
      this.setPos()
    }
  },
  mounted () {
    this.getItem()

    if (sessionStorage.getItem('s_query')) {
      let query = sessionStorage.getItem('s_query').substring(1)

      if (query.charAt(0) === '?') {
        query = query + '&nav=1'
      } else {
        query = '?nav=1'
      }

      axios.get(process.env.VUE_APP_API_ENDPOINT + '/search' + query)
      .then(response => {
        this.nav = response.data.items
        this.setPos()
      })
      .catch(() => {
        console.log('Could not fetch page navigation data.')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/modules/_breakpoints.scss';
@import '@/assets/scss/modules/_variables.scss';

.centered {
  min-height: 400px;
  padding-top: 80px;
  text-align: center;
  line-height: 3;
}

.centered-link {
  margin-top: 16px;
  display: inline-block;
}

.centered-link .fas {
  margin-right: 8px;
}

.item-header {
  height: 48px;
  display: flex;

  @include breakpoint-up($md) {
    height: 35px;
    justify-content: flex-end;
  }
}

.item-header-nav {
  color: map-get($colors, gray-medium);
  font-size: 1.6rem;
  width: 50%;
  height: 100%;
  text-align: center;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;

  @include breakpoint-up($md) {
    font-size: 1.3rem;
    width: 127px;
  }
}

.item-header-nav-prev:hover,
.item-header-nav-next:hover {
  color: map-get($colors, green-dark);
}

.item-header-nav-prev .fas,
.item-header-nav-prev-inactive .fas {
  margin-right: 6px;
}

.item-header-nav-next .fas,
.item-header-nav-next-inactive .fas {
  margin-left: 6px;
}

.item-header-nav-prev-inactive,
.item-header-nav-next-inactive {
  color: map-get($colors, gray-light);
}

.item-contact {
  background-color: rgba(255,255,255,0.85);
  border-top: 1px solid map-get($colors, gray-white);
  width: 100%;
  padding-top: 2px;
  padding-bottom: 16px;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 500;

  @include breakpoint-up($md) {
    display: none;
  }
}

.item-contact-actions {
  margin-top: 12px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
}

.item-contact-actions-button {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  flex: 1;
}

.item-contact-actions-button:first-of-type {
  margin-right: 12px;
}

.item-category {
  color: map-get($colors, gray-medium);
  font-size: 1.6rem;
  margin-top: 12px;
  margin-bottom: 12px;
  display: block;

  @include breakpoint-up($md) {
    font-size: 1.3rem;
    margin-top: 16px;
    margin-bottom: 16px;
  }
}

.item-category .fas {
  color: #a6a6a6;
  margin-left: 2px;
  margin-right: 2px;
}

.item-image-carousel {
  margin-left: -16px;
  margin-right: -16px;

  @include breakpoint-up($md) {
    margin-left: 0;
    margin-right: 0;
  }
}

.item-body {
  display: flex;
}

.item-main {
  flex: 1;
}

.item-carousel-wrapper {
  margin-bottom: 24px;
}

.item-details {
  @include breakpoint-up($md) {
    padding-bottom: 32px;
  }
}

.item-details-meta {
  color: map-get($colors, gray-medium);
  margin-top: 16px;
  margin-bottom: 24px;
  display: flex;

  @include breakpoint-up($md) {
    display: none;
  }
}

.item-details-meta .fas {
  color: #a6a6a6;
  margin-right: 6px;
}

.item-details-meta-location {
  padding-right: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  flex: 1;
}

.item-details-meta-date {
  margin-left: auto;
}

.item-details-title {
  font-size: 2.4rem;
  font-weight: 700;

  @include breakpoint-up($md) {
    margin-bottom: 24px;
  }
}

.item-details-price {
  color: map-get($colors, green-base);
  font-size: 2.4rem;
  font-weight: 700;
  margin-top: 8px;
  margin-bottom: 24px;
  display: block;

  @include breakpoint-up($md) {
    display: none;
  }
}

.item-details-user {
  margin-bottom: 24px;
  display: block;

  @include breakpoint-up($md) {
    display: none;
  }
}

.item-details-heading {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 12px;

  @include breakpoint-up($md) {
    font-size: 1.4rem;
  }
}

.item-details-bottom {
  color: map-get($colors, gray-base);
  margin-top: 42px;
  display: flex;

  @include breakpoint-up($md) {
    font-size: 1.3rem;
  }
}

.item-details-footer {
  background-color: map-get($colors, gray-whiter);
  border-top: 1px solid map-get($colors, gray-white);
  margin-top: 24px;
  margin-left: -16px;
  margin-right: -16px;
  padding:  24px 16px;
  text-align: center;

  @include breakpoint-up($md) {
    display: none;
  }
}

.item-details-footer-edit-button {
  padding-top: 12px;
  padding-bottom: 12px;
}

.item-meta {
  width: 260px;
  padding-left: 24px;
  display: none;

  @include breakpoint-up($md) {
    display: block;
  }
}

.item-meta-box {
  background-color: map-get($colors, gray-whiter);
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 16px;

  @include breakpoint-up($md) {
    font-size: 1.3rem;
  }
}

.item-meta-box-price {
  color: map-get($colors, green-base);
  font-size: 2.4rem;
  font-weight: 700;
  text-align: right;
}

.item-meta-box-list {
  margin-top: 16px;
}

.item-meta-box-list-item {
  border-top: 1px solid map-get($colors, gray-lightest);
  padding-top: 8px;
  padding-bottom: 8px;
  display: flex;
}

.item-meta-box-list-item:last-child {
  padding-bottom: 0;
}

.item-meta-box-list-item-key {
  color: map-get($colors, gray-medium);
  font-weight: 700;
}

.item-meta-box-list-item-val {
  margin-left: auto;
}

.item-meta-box-user {
  color: map-get($colors, gray-medium);
  font-weight: 700;
  margin-bottom: 16px;
  text-align: center;
}

.item-meta-box-button {
  width: 100%;
}

.item-meta-box-phone-button {
  margin-top: 8px;
  display: block;
}

.item-report-button {
  color: map-get($colors, gray-base);
  cursor: pointer;
  margin-left: auto;
}

.item-report-button .fas {
  color: map-get($colors, gray-light);
  cursor: pointer;
  margin-right: 6px;
}

.item-report-button:hover {
  color: map-get($colors, red-base);
  text-decoration: underline;
}

.item-report-button:hover .fas {
  color: map-get($colors, red-base);;
}
</style>
